import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'dateRangeArray',
})
export class DateRangeArrayPipe implements PipeTransform {
  transform(value: Date | [Date, Date], selectionMode: 'single' | 'range'): Date[] {
    if (selectionMode === 'range') {
      if (Array.isArray(value)) {
        return value;
      } else if (value) {
        return [value, value];
      } else {
        return [null, null];
      }
    } else {
      return [value as Date];
    }
  }
}
